/**
 * App entry point.
 */

// qpl-client must be imported BEFORE App so its module-load side effect
// installs the nav-flow before App's import graph evaluates store/sagas.
// The moment `import { App }` is evaluated, the store module runs
// sagaMiddleware.run(rootSaga); the auth + plugin bootstrap sagas then
// start emitting flow points via `withSagaFlow`. Without an already-
// active nav flow, those first sagas own root flows and clutter the
// dashboard. ES module evaluation is depth-first in import order; this
// import line ensures qpl-client's nav-flow side effect installs first.
import { initQPL } from '@/features/qpl-client';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { bootstrapAppDefaults } from '@/infra/wasm/AppDefaults';
import './styles/variables.css';
import './styles/global.css';

// Reaps orphan flows from the previous page load and starts the upload
// transport pointing at chores' /api/v1/qpl proxy. Nav-flow itself is
// already installed via the qpl-client module-load side effect above.
initQPL();

// Fire and forget: AppDefaults snapshot has compile-time-safe
// fallbacks so the React tree can mount immediately. The wasm
// load updates the snapshot when it lands (~100ms cold); first-
// frame consumers see the fallback values, post-bootstrap reads
// see the wasm-sourced ones. Pre-bootstrap consumers like
// TodoForm get the same numbers either way because the fallbacks
// mirror Go's compile-time constants.
void bootstrapAppDefaults();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
